<div
  id="kt_app_header"
  class="app-header"
  data-kt-sticky="true"
  data-kt-sticky-activate="{default: true, lg: true}"
  data-kt-sticky-name="app-header-minimize"
  data-kt-sticky-offset="{default: '200px', lg: '0'}"
  data-kt-sticky-animation="false"
>
  <div
    class="app-container container-fluid d-flex align-items-stretch justify-content-between"
    id="kt_app_header_container"
  >
    <div
      class="d-flex align-items-center d-lg-none ms-n3 me-1 me-md-2"
      title="Show sidebar menu"
    >
      <div
        class="btn btn-icon btn-active-color-primary w-35px h-35px"
        id="kt_app_sidebar_mobile_toggle"
      >
        <i class="ki-duotone ki-abstract-14 fs-2 fs-md-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
    </div>
    <div
      class="d-flex align-items-stretch justify-content-between flex-lg-grow-1"
      id="kt_app_header_wrapper"
    >
      <div
        class="app-header-menu app-header-mobile-drawer align-items-stretch"
        data-kt-drawer="true"
        data-kt-drawer-name="app-header-menu"
        data-kt-drawer-activate="{default: true, lg: false}"
        data-kt-drawer-overlay="true"
        data-kt-drawer-width="250px"
        data-kt-drawer-direction="end"
        data-kt-drawer-toggle="#kt_app_header_menu_toggle"
        data-kt-swapper="true"
        data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
        data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
      >
        <div
          class="menu menu-rounded menu-column menu-lg-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0"
          id="kt_app_header_menu"
          data-kt-menu="true"
        ></div>
      </div>
      <div class="app-navbar flex-shrink-0">
        <!-- Theme Selection -->
        <div class="app-navbar-item ms-1 ms-md-4">
          <a
            class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px"
            data-kt-menu-trigger="hover"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end"
            title="Theme Selection"
          >
            <svg
              class="theme-light-show theme-mode-icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <circle cx="12" cy="12" r="4" />
              <path
                d="M12 2.5v2.25M12 19.25v2.25M4.75 12H2.5M21.5 12h-2.25M5.64 5.64l1.59 1.59M16.77 16.77l1.59 1.59M18.36 5.64l-1.59 1.59M7.23 16.77l-1.59 1.59"
              />
            </svg>
            <i class="fa-solid fa-moon theme-dark-show"></i>
          </a>
          <div
            class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-4 fs-base w-150px"
            data-kt-menu="true"
            data-kt-element="theme-mode-menu"
          >
            <div class="menu-item px-3 my-0">
              <a
                class="menu-link px-3 py-2 cursor-pointer"
                (click)="setTheme('light')"
              >
                <span class="menu-icon" data-kt-element="icon">
                  <svg class="theme-mode-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="12" r="4" />
                    <path
                      d="M12 2.5v2.25M12 19.25v2.25M4.75 12H2.5M21.5 12h-2.25M5.64 5.64l1.59 1.59M16.77 16.77l1.59 1.59M18.36 5.64l-1.59 1.59M7.23 16.77l-1.59 1.59"
                    />
                  </svg>
                </span>
                <span class="menu-title">{{ "lightMode" | translate }}</span>
              </a>
            </div>
            <div class="menu-item px-3 my-0">
              <a
                class="menu-link px-3 py-2 cursor-pointer"
                (click)="setTheme('dark')"
              >
                <span class="menu-icon" data-kt-element="icon">
                  <i class="fa-solid fa-moon"></i>
                </span>
                <span class="menu-title">{{ "darkModes" | translate }}</span>
              </a>
            </div>
          </div>
        </div>
        <!-- User Menu -->
        <div
          class="app-navbar-item ms-1 ms-md-4"
          id="kt_header_user_menu_toggle"
        >
          <div
            class="d-flex align-items-center cursor-pointer symbol symbol-35px"
            data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end"
          >
            <img
              src="assets/media/avatars/user-profile-icon.jpg"
              class="rounded-3"
              alt="user"
            />
            <div class="me-1 d-none d-sm-block">
              <a class="text-gray-900 text-hover-primary fs-6 fw-bold p-2">{{
                currentUser?.name
              }}</a>
            </div>
            <i
              class="d-none d-sm-block fa-solid fa-angle-down text-gray-500 pt-1"
            ></i>
          </div>
          <div
            class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
            data-kt-menu="true"
          >
            <div class="menu-item px-3">
              <div class="menu-content d-flex align-items-center px-3">
                <div class="symbol symbol-50px me-5">
                  <img
                    alt="Logo"
                    src="assets/media/avatars/user-profile-icon.jpg"
                  />
                </div>
                <div class="d-flex flex-column">
                  <div class="fw-bold d-flex align-items-center fs-5">
                    {{ currentUser?.name }}
                    <span
                      class="badge fw-bold fs-8 px-2 py-1 ms-2"
                      [ngClass]="statusClass"
                      >{{ statusText }}</span
                    >
                  </div>
                  <a class="fw-semibold text-muted text-hover-primary fs-7">{{
                    currentUser?.email
                  }}</a>
                  <a class="fw-semibold text-muted text-hover-primary fs-7">{{
                    currentUser?.customerCode || ""
                  }}</a>
                </div>
              </div>
            </div>
            <div class="menu-item px-5">
              <a (click)="logout()" class="menu-link">
                <span class="menu-title">{{ "logout" | translate }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
